"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractProducers = void 0;
var isObjectLike_1 = __importDefault(require("lodash/isObjectLike"));
var uniqBy_1 = __importDefault(require("lodash/uniqBy"));
var values_1 = __importDefault(require("lodash/values"));
var flattenDeep_1 = __importDefault(require("lodash/flattenDeep"));
var isProducer_1 = require("./isProducer");
var extractProducers = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var result = (0, flattenDeep_1.default)(args);
    result = result.map(function (x) {
        if ((0, isProducer_1.isProducer)(x)) {
            return x;
        }
        else if ((0, isObjectLike_1.default)(x)) {
            return (0, values_1.default)(x).map(function (y) {
                if ((0, isProducer_1.isProducer)(y)) {
                    return y;
                }
                else {
                    return (0, exports.extractProducers)(y);
                }
            });
        }
    });
    result = (0, flattenDeep_1.default)(result);
    result = result.filter(isProducer_1.isProducer);
    result = (0, uniqBy_1.default)(result, "buildId");
    return result;
};
exports.extractProducers = extractProducers;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXh0cmFjdFByb2R1Y2Vycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9leHRyYWN0UHJvZHVjZXJzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUNBLHFFQUErQztBQUMvQyx5REFBbUM7QUFDbkMseURBQW1DO0FBQ25DLG1FQUE2QztBQUM3QywyQ0FBMEM7QUFFbkMsSUFBTSxnQkFBZ0IsR0FBRztJQUFDLGNBQWtCO1NBQWxCLFVBQWtCLEVBQWxCLHFCQUFrQixFQUFsQixJQUFrQjtRQUFsQix5QkFBa0I7O0lBQ2pELElBQUksTUFBTSxHQUFjLElBQUEscUJBQVcsRUFBQyxJQUFJLENBQUMsQ0FBQztJQUUxQyxNQUFNLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQyxVQUFDLENBQUM7UUFDcEIsSUFBSSxJQUFBLHVCQUFVLEVBQUMsQ0FBQyxDQUFDLEVBQUU7WUFDakIsT0FBTyxDQUFDLENBQUM7U0FDVjthQUFNLElBQUksSUFBQSxzQkFBWSxFQUFDLENBQUMsQ0FBQyxFQUFFO1lBQzFCLE9BQU8sSUFBQSxnQkFBTSxFQUFDLENBQUMsQ0FBQyxDQUFDLEdBQUcsQ0FBQyxVQUFDLENBQUM7Z0JBQ3JCLElBQUksSUFBQSx1QkFBVSxFQUFDLENBQUMsQ0FBQyxFQUFFO29CQUNqQixPQUFPLENBQUMsQ0FBQztpQkFDVjtxQkFBTTtvQkFDTCxPQUFPLElBQUEsd0JBQWdCLEVBQUMsQ0FBQyxDQUFDLENBQUM7aUJBQzVCO1lBQ0gsQ0FBQyxDQUFDLENBQUM7U0FDSjtJQUNILENBQUMsQ0FBQyxDQUFDO0lBRUgsTUFBTSxHQUFHLElBQUEscUJBQVcsRUFBQyxNQUFNLENBQUMsQ0FBQztJQUM3QixNQUFNLEdBQUcsTUFBTSxDQUFDLE1BQU0sQ0FBQyx1QkFBVSxDQUFDLENBQUM7SUFDbkMsTUFBTSxHQUFHLElBQUEsZ0JBQU0sRUFBQyxNQUFNLEVBQUUsU0FBUyxDQUFDLENBQUM7SUFFbkMsT0FBTyxNQUEwQixDQUFDO0FBQ3BDLENBQUMsQ0FBQztBQXRCVyxRQUFBLGdCQUFnQixvQkFzQjNCIn0=